import { WATER_LEVEL } from "./constants";
import { Box } from "./react-graphics";

const Water = () => {
  return (
    <Box
      x={-2000}
      y={-WATER_LEVEL}
      width={4000}
      height={1000}
      fillColor={0x77ddaa}
    />
  );
};

export default Water;
